import React from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { observer } from "mobx-react";
import { store } from "../../../store";
import { LengthUnit } from "../../../api";

type LengthUnitSelectorOption = {
    key: string;
    text: string;
    value: LengthUnit | "default";
};

export type LengthUnitSelectorProps = {
    value?: LengthUnit;
    onChange: (unit?: LengthUnit) => void;
};

export const LengthUnitSelector = observer(({ onChange, value }: LengthUnitSelectorProps) => {
    const options: LengthUnitSelectorOption[] = [
        {
            key: "default",
            value: "default",
            text: store.i18n.t("component.lengthUnitSelector.default"),
        },
        {
            key: LengthUnit.METERS,
            value: LengthUnit.METERS,
            text: store.i18n.t("component.lengthUnitSelector.meters"),
        },
        {
            key: LengthUnit.FEET,
            value: LengthUnit.FEET,
            text: store.i18n.t("component.lengthUnitSelector.feet"),
        },
    ];

    return (
        <Select
            value={value ?? "default"}
            onValueChange={(value) => {
                if (value === "default") {
                    onChange(undefined);
                    return;
                } else {
                    onChange(value as LengthUnit);
                }
            }}
        >
            <SelectTrigger className={cn("w-[120px]")}>
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                {options.map((o) => (
                    <SelectItem value={o.value} key={o.key}>
                        {o.text}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
});
